<template>
  <div class="singleCreativeUnit">
    <spinner v-if="loading" />
    <breadcrumb :links="breadcrumb" />
      <div class="pageContent">
      <heading-wrap>
        <span slot="title"><span class="text-uppercase">{{ this.creativeName }}</span></span>
      </heading-wrap>
      <div class="row sticky-top">
        <div class="col-sm-3">
          <div class="btn-group" role="group" aria-label="Layout">
            <button class="btn btn-default btn-xs" :class="layoutView('columns')"  @click="changeLayout('columns')"><i class="fa fa-columns"></i></button>
            <button class="btn btn-default btn-xs" :class="layoutView('rows')" @click="changeLayout('rows')"><i class="fa fa-calculator"></i></button>
          </div>
          <span> Date Created: {{ this.date_created | formatDate }}</span>
          <span v-if="this.status === 'error'">
            <tooltip :text="this.creativeUnit.status_message">
              Status:&nbsp;
              <span
                  :class="statusCss(this.status)">
                <i class="fa fa-exclamation-triangle"></i>
                 {{ this.status }}
              </span>
            </tooltip>
          </span>
          <span v-else>
            Status:&nbsp;
            <span :class="statusCss(this.status)">
              <i v-if='status == "queued"' class="fa fa-spinner"></i> {{ this.status }}
            </span>
          </span>
        </div>
        <div class="col-sm-9 text-right">
            <slot v-if="editing == true">
              <button-cta :onClick="saveUnit" :data-rowId="this && this.id" :class="`btn-sm btn-success`">
                <i class="fa fa-save"></i> Save changes
              </button-cta>
              <button-cta class="btn-sm btn-danger" :onClick="cancel"><i class="fa fa-close"></i> Cancel</button-cta>
            </slot>
            <button-cta v-if="(status == 'edited' || status == 'new') && editing == false" class="btn-sm btn-info" :onClick="renderUnit"><i class="fa fa-magic"></i> Render</button-cta>
            <a v-if="status == 'rendered' && editing == false && type == 'html-video'" target="_blank" class="btn btn-sm btn-success" @click="onLaunchChargeModal('html-video')"><i class="fa fa-download"></i> Download Zip  ({{ creativeUnit.render_video_format }})</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export`" -->
            <a v-if="status == 'rendered' && editing == false && type == 'html'" target="_blank" class="btn btn-sm btn-success" @click="onLaunchChargeModal('html')"><i class="fa fa-download"></i> Download Zip (HTML)</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export`" -->
            <a v-if="status == 'rendered' && editing == false && type == 'psd'" target="_blank" class="btn btn-sm btn-success" @click="onLaunchChargeModal('jpg')"><i class="fa fa-download"></i> Download .jpg</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export-jpg`"  -->
            <a v-if="status == 'rendered' && editing == false && type == 'psd'" target="_blank" class="btn btn-sm btn-success" @click="onLaunchChargeModal('png')"><i class="fa fa-download"></i> Download .png</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export-png`"  -->
            <a v-if="status == 'rendered' && editing == false && type == 'psd'" target="_blank" class="btn btn-sm btn-success" @click="onLaunchChargeModal('gif')"><i class="fa fa-download"></i> Download .gif</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export-gif`"  -->
            <a v-if="status == 'rendered' && editing == false && type == 'psd'" target="_blank" class="btn btn-sm btn-info" @click="onLaunchChargeModal('psd')"><i class="fa fa-download"></i> Download .psd</a> <!-- :href="`${baseUrl}api_v2/creative/${creativeId}/single/${creativeUnitId}/export-psd`"  -->
        </div>
      </div>
      <!-- CREATIVE DATA FORM -->
      <div class="row">
        <div class="text-center sticky-top-last" :class="creativeDataLayoutView('preview')" id="previewHolder">
          <div class="card replayHolder" v-if=(showReplay)>
            <div class="card-body">
              <button-cta v-if="type == 'html'" :onClick="replay" :class="`btn btn-xs btn-warning`"><i class="fa fa-repeat"></i> Replay</button-cta>
              <div v-if="type == 'psd'" class="btn-group" role="group" aria-label="Layout">
                <button-cta :class="`btn-xs btn-warning`" :onClick="replayPNG"><i class="fa fa-repeat"></i> PNG</button-cta>
                <button-cta :class="`btn-xs btn-warning`" :onClick="replayJPG">JPG</button-cta>
                <button-cta :class="`btn-xs btn-warning`" :onClick="replayGIF">GIF</button-cta>
              </div>
            </div>
          </div>
          <div id="iFrameContainer">
            <div v-if="type === 'html-video' && status === 'rendered'" class="singleCreativeUnit__video-preview">
              <video v-if="videoPreview.type === 'mp4'" :width="creativeUnit.width" :height="creativeUnit.height" controls autoplay loop controlslist="nodownload" oncontextmenu="return false;">
                <source :src="videoPreview.url" type="video/mp4">
                Your browser does not support the video tag.
              </video>
              <img v-if="videoPreview.type === 'gif'"
                   :key="videoPreview.url"
                   :src="videoPreview.url"
                   class="vue-lb-modal-image">
            </div>
            <div id="iframeHolder"></div>
            <div v-if="(type !== 'html')" id="iframeCover"></div>
          </div>
        </div>

        <div :class="creativeDataLayoutView('creativeData')">
          <div class="card">
            <div class="card-body">
              <form>
              <h4 class="col-sm-12">Mandatory Fields</h4>
              <div class="form-group col-sm-3">
                <div class="field" value="value">
                  <label class="control-label">master</label>
                  <label v-if="editing == true" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning"><i class="fa fa-undo"></i></button></label>
                  <textarea type="textarea" class="form-control" disabled v-model=creativeUnitSystemData.master></textarea>
                </div>
              </div>
              <div class="form-group col-sm-3">
                <div class="field" value="value">
                    <label class="control-label">locale</label>
                    <label v-if="editing == true && (creativeUnitSystemData.locale != originalCreativeUnitSystemData.locale)" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('locale')"><i class="fa fa-undo"></i></button></label>
                    <textarea type="text" placeholder="locale" class="form-control" name="locale" v-model="creativeUnitSystemData.locale" @keyup="checkEditingSystem('locale', creativeUnitSystemData.locale)" :disabled="disableEdition()"></textarea>
                </div>
              </div>
              <div class="form-group col-sm-3">
                <div class="field" value="value">
                    <label class="control-label">width</label>
                    <label v-if="editing == true && (creativeUnitSystemData.width != originalCreativeUnitSystemData.width)" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('width')"><i class="fa fa-undo"></i></button></label>
                    <textarea type="text" placeholder="width in px" class="form-control" name="width" v-model="creativeUnitSystemData.width" @keyup="checkEditingSystem('width', creativeUnitSystemData.width)" :disabled="disableEdition()"></textarea>
                </div>
              </div>
              <div class="form-group col-sm-3">
                <div class="field" value="value">
                    <label class="control-label">height</label>
                    <label v-if="editing == true && (creativeUnitSystemData.height != originalCreativeUnitSystemData.height)" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('height')"><i class="fa fa-undo"></i></button></label>
                    <textarea type="text" placeholder="height in px" class="form-control" name="height" v-model="creativeUnitSystemData.height" @keyup="checkEditingSystem('height', creativeUnitSystemData.height)" :disabled="disableEdition()"></textarea>
                </div>
              </div>
                <div class="col-sm-12"></div>
              <div class="form-group col-sm-3" v-if="type === 'html-video'">
                <div class="field" value="value">
                  <label class="control-label">render_video_duration</label>
                  <label
                      v-if="editing == true && (creativeUnitSystemData.render_video_duration != originalCreativeUnitSystemData.render_video_duration)"
                      class="control-label pull-right" title="Revert change">
                    <button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('render_video_duration')"><i
                        class="fa fa-undo"></i></button>
                  </label>
                  <input type="number" placeholder="duration in seconds" class="form-control"
                            name="render_video_duration" v-model="creativeUnitSystemData.render_video_duration"
                            @keyup="checkEditingSystem('render_video_duration', creativeUnitSystemData.render_video_duration)"
                            :disabled="disableEdition()" />
                </div>
              </div>
              <div class="form-group col-sm-3" v-if="type === 'html-video'">
                <div class="field" value="value">
                  <label class="control-label">render_video_fps</label>
                  <label
                      v-if="editing == true && (creativeUnitSystemData.render_video_fps != originalCreativeUnitSystemData.render_video_fps)"
                      class="control-label pull-right" title="Revert change">
                    <button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('render_video_fps')"><i
                        class="fa fa-undo"></i></button>
                  </label>
                  <select id="render_video_fps" name="render_video_fps" class="form-control"
                          v-model="creativeUnitSystemData.render_video_fps"
                          @change="checkEditingSystem('render_video_fps', creativeUnitSystemData.render_video_fps)"
                          :disabled="disableEdition()"
                  >
                    <option v-for="(value, key) in fpsOptions" :key="key" :value="key">{{ value }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group col-sm-3" v-if="type === 'html-video'">
                <div class="field" value="value">
                  <label class="control-label">render_video_format</label>
                  <label
                      v-if="editing == true && (creativeUnitSystemData.render_video_format != originalCreativeUnitSystemData.render_video_format)"
                      class="control-label pull-right" title="Revert change">
                    <button class="btn-xs btn-warning" @click.prevent="revertChangeSystem('render_video_format')"><i
                        class="fa fa-undo"></i></button>
                  </label>
                  <select id="render_video_format" name="render_video_format" class="form-control"
                          v-model="creativeUnitSystemData.render_video_format"
                          @change="checkEditingSystem('render_video_format', creativeUnitSystemData.render_video_format)"
                          :disabled="disableEdition()"
                  >
                    <option v-for="(value, key) in videoFormats" :key="key" :value="key">{{ value }}</option>
                  </select>
                </div>
              </div>
              <h4 class="col-sm-12">Creative Data</h4>
                <div v-for="(value, key) in this.creativeUnitData" :key="key" class="form-group col-sm-3">
                  <div v-if="fieldData(key).type == 'string' || fieldData(key).type == 'number'" class="field" value="value">
                    <label class="control-label">{{ key }}</label>
                    <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                    <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                    <textarea :placeholder="fieldData(key).defaultValue" type="textarea" class="form-control" :name="key" v-model="creativeUnitData[key]" @keyup="checkEditing(key, value)" :disabled="disableEdition()"></textarea>
                  </div>
                  <div v-else-if="fieldData(key).type == 'yesno'" class="field" value="value">
                     <div class="form-group">
                        <label class="control-label">{{ key }}</label>
                        <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                        <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                        <select class="form-control" :id="key" v-model.lazy="creativeUnitData[key]" v-on:change="checkSelection(key, $event)" :disabled="disableEdition()">
                          <option value="" selected disabled>Please select a value</option>
                          <option value="no">No</option>
                          <option value="yes">Yes</option>
                        </select>
                      </div>
                  </div>
                  <div v-else-if="fieldData(key).type == 'alignment'" class="field" value="value">
                     <div class="form-group">
                        <label class="control-label">{{ key }}</label>
                        <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                        <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                        <select class="form-control" :id="key" v-model.lazy="creativeUnitData[key]" v-on:change="checkSelection(key, $event)" :disabled="disableEdition()">
                          <option value="" selected disabled>Please select a value</option>
                          <option value="left">left</option>
                          <option value="center">center</option>
                          <option value="right">right</option>
                        </select>
                      </div>
                  </div>
                  <div v-else-if="fieldData(key).type == 'boolean' || fieldData(key).type == 'constrain' || fieldData(key).type == 'keepaspect'" class="field" value="value">
                     <div class="form-group">
                        <label class="control-label">{{ key }}</label>
                        <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                        <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                        <select class="form-control" :id="key" v-model.lazy="creativeUnitData[key]" v-on:change="checkSelection(key, $event)" :disabled="disableEdition()">
                          <option selected disabled>Please select a value</option>
                          <option value="0">False</option>
                          <option value="1">True</option>
                        </select>
                      </div>
                  </div>
                  <div v-else-if="fieldData(key).type === 'color'" class="field" value="value">
                    <div class="form-group">
                        <label class="control-label">{{ key }}</label>
                        <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                        <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                        <span v-if="allowResetDefaults()">
                          <color-picker v-model="creativeUnitData[key]" :color="creativeUnitData[key]" :creativeType='type' @input="checkEditing(key, value)"/>
                        </span>
                        <span v-else>
                          <slot v-if="creativeUnitData[key]">
                            <div class="colorPicker">{{ creativeUnitData[key] }}<span :style="{ backgroundColor: creativeUnitData[key] }">&nbsp;</span></div>
                          </slot>
                          <slot v-else>
                            No color has been set.
                          </slot>
                        </span>
                    </div>
                  </div>
                  <div v-else-if="fieldData(key).type === 'video'" class="imageHolder">
                     <label class="control-label">{{ key }}</label>
                      <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                      <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                      <div class="imageHolderContent"
                        @click="updateImage"
                        data-modalType="assetLibrary"
                        :data-modalID="fieldData(key).id"
                        :data-modalField="key"
                        :data-modalFieldType="fieldData(key).type">
                        <div v-if='value == ""'>
                          <video :id="key" width="100%" controls playsinline="true" :poster='videoThumbPath(fieldData(key).defaultValue)' preload="none" controlslist="nodownload">
                            <source :src="thumbPath(fieldData(key).defaultValue)" type="video/mp4">
                            Your browser does not support the video tag.
                          </video>
                          <div class='imageName text-center'><span>{{ fieldData(key).defaultValue }}</span></div>
                          <div v-if="allowResetDefaults()" class='text-center'><i aria-hidden="true" class="fa fa-plus"></i> Select Video</div>
                        </div>
                        <div v-else>
                          <video :id="key" width="100%" controls playsinline="true" :poster='videoThumbPath(creativeUnitData[key])' preload="none" controlslist="nodownload">
                            <source :src="thumbPath(creativeUnitData[key])" type="video/mp4">
                            Your browser does not support the video tag.
                          </video>
                          <div class='imageName text-center'><span>{{ value }}</span></div>
                          <div v-if="allowResetDefaults()" class='text-center'><i aria-hidden="true" class="fa fa-edit"></i> (click to edit)</div>
                        </div>
                      </div>
                  </div>
                  <div v-else class="imageHolder">
                      <label class="control-label">{{ key }}</label>
                      <label v-if="allowResetDefaults()" class="control-label pull-right set-default" title="Use default"><button class="btn-xs btn-info" @click.prevent="setDefault(key)"><i class="fa fa-certificate"></i></button></label>
                      <label v-if="editing == true && (creativeUnitData[key] != originalCreativeUnitData[key])" class="control-label pull-right" title="Revert change"><button class="btn-xs btn-warning" @click.prevent="revertChange(key)"><i class="fa fa-undo"></i></button></label>
                      <div class="imageHolderContent"
                        @click="updateImage"
                        data-modalType="assetLibrary"
                        :data-modalID="fieldData(key).id"
                        :data-modalField="key"
                        :data-modalFieldType="fieldData(key).type">
                        <div v-if='value == ""'>
                          <img :src='thumbPath(fieldData(key).defaultValue)' onerror="this.src='https://via.placeholder.com/300x200/526291/fff?text=Image+Missing'" />
                          <div class='imageName text-center'><span>{{ fieldData(key).defaultValue }}</span></div>
                          <div v-if="allowResetDefaults()" class='text-center'><i aria-hidden="true" class="fa fa-plus"></i> Add Image</div>
                        </div>
                        <div v-else>
                          <img :src='thumbPath(creativeUnitData[key])' onerror="this.src='https://via.placeholder.com/300x200/526291/fff?text=Image+Missing'" />
                          <div class='imageName text-center'><span>{{ value }}</span></div>
                          <div v-if="allowResetDefaults()" class='text-center'><i aria-hidden="true" class="fa fa-edit"></i> (click to edit)</div>
                        </div>
                      </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <portal to="globalModal">
      <modal-asset-library :show="showModal.assetLibrary" :type="modalType" :confirmId="this.creativeUnits.creativeUnits ? this.creativeUnits.creativeUnits.creative.hash_id : ''" :field="modalField" :fieldType="modalFieldType" @selectImage="onSelectImage" @close="toggleModal('assetLibrary')"/>
      <modal-charge-single-confirmation
          :show="showModal.chargeSingleConfirmation"
          :type="modalType"
          :confirmId="modalId"
          :charges="charges"
          v-on:downloadFile="downloadFile"
          @close="toggleModal('chargeSingleConfirmation')" />
    </portal>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import Spinner from '@/components/SpinnerIcon/spinner'
import ButtonCta from '@/components/Button/button'
import UploadFile from '@/components/UploadFile/upload-file'
import ModalAssetLibrary from '@/components/Modal/assets/modal-asset-library'
import ModalChargeSingleConfirmation from '@/components/Modal/creatives/modal-charge-single-confirmation'
import ColorPicker from '@/components/ColorPicker/color-picker'

import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import Breadcrumb from '@/components/Breadcrumb/breadcrumb'
import Tooltip from '@/components/Tooltip/tooltip'
import {downloadMixin} from '@/mixins/downloadMixin'

import { url, devMode, API_URL, MEDIA_URL } from '@/config'

import {} from 'ramda'

export default {
  name: 'single-creative-unit',
  mixins: [modalMixin, creativeMixin, notificationMixin, downloadMixin],
  components: {
    HeadingWrap,
    Spinner,
    ButtonCta,
    ModalAssetLibrary,
    ModalChargeSingleConfirmation,
    UploadFile,
    Breadcrumb,
    Tooltip,
    ColorPicker
  },
  created () {
    this.editing = false
    this.refreshCreativeUnit()
  },
  data: () => ({
    creativeUnit: Object,
    creativeUnitData: Object,
    originalCreativeUnitData: Object,
    creativeUnitSystemData: {
      master: String,
      locale: String,
      width: Number,
      height: Number,
      render_video_duration: Number,
      render_video_fps: Number,
      render_video_format: String
    },
    originalCreativeUnitSystemData: Object,
    breadcrumb: [],
    creativeName: '',
    editing: Boolean,
    layout: 'rows',
    status: '',
    type: '',
    date_created: '',
    showReplay: Boolean,
    replayFormat: 'png',
    statusKeys: {
      rendered: 'success',
      edited: 'info',
      error: 'danger',
      under_review: 'warning',
      queued: 'warning'
    },
    charges: {
      alreadyDownloaded: false,
      downloadCost: 0,
      currency: 'gpb',
      downloadFormat: ''
    },
    polling: {
      time: 3000
    },
    id: ''
  }),
  methods: {
    allowResetDefaults () {
      if (this.creativeUnit.readOnly) {
        return false
      }
      return this.status !== 'queued'
    },
    disableEdition () {
      if (this.creativeUnit.readOnly) {
        return true
      }
      return this.status === 'queued'
    },
    // this.getCreativeUnits(this.creativeUnitId).then(() => {
    fieldData (item) {
      var valObj = this.creativeUnit.creative.fields.filter(function (elem) {
        if (elem.name === item) {
          return elem.name
        }
      })
      if (valObj.length > 0) {
        let defaultValue = valObj[0].defaultValue
        if (valObj[0].default_values && valObj[0].default_values.length) {
          const masterDefault = valObj[0].default_values.find(defaultValue => {
            return defaultValue.master === this.creativeUnitSystemData.master
          })
          if (masterDefault) {
            if (item.type === 'image') {
              defaultValue = `${item.image_preview_prefix}/${masterDefault.value}`
            } else {
              defaultValue = masterDefault.value
            }
          }
        }
        valObj[0].defaultValue = defaultValue
        return valObj[0]
      }
    },
    nothing () {
    },
    layoutView (choice) {
      if (choice === this.layout) {
        return 'btn-success'
      } else {
        return ''
      }
    },
    creativeDataLayoutView (item) {
      if (this.layout === 'rows') {
        return 'col-sm-12'
      } else {
        if (item === 'preview') {
          return 'col-sm-3'
        } else {
          return 'col-sm-9'
        }
      }
    },
    changeLayout (choice) {
      this.layout = choice
      this.createPreview()
    },
    createPreview () {
      // destroy existing iframe first
      var iframeHolder = document.getElementById('iframeHolder')
      iframeHolder.innerHTML = ''
      var iframe = document.createElement('iframe')
      iframe.src = this.previewUrl
      iframe.width = this.creativeUnit.width
      iframe.height = this.creativeUnit.height
      iframe.scrolling = 'no'
      iframe.id = 'iframe'
      iframe.style = 'border:none;'
      // code to work out whether or not to show replay & format controls
      if (this.previewUrl === API_URL + 'assets/img/placeholder.png' || this.previewUrl === 'http://otomo.local:8081/no-preview') {
        this.showReplay = false
      } else {
        this.showReplay = true
      }
      iframeHolder.appendChild(iframe) // add it to wherever you need it in the document
      document.getElementById('iframe').onload = () => {
      }
      if (this.type === 'html-video') {
        // If there is Rendered video, avoid contextual menu (right click event).
        document.addEventListener('contextmenu', this.disableContextMenu, false)
      }
    },
    disableContextMenu (e) {
      e.preventDefault()
    },
    pollRender () {
      if (this.status === 'queued') {
        setTimeout(() => {
          this.getCreativeUnit(this.creativeUnitId).then(() => {
            this.refreshCreativeUnit()
            // Poll queue
          })
        }, this.polling.time)
      }
    },
    replay () {
      document.getElementById('iframe').src = this.previewUrl
    },
    replayJPG () {
      // this.replayFormat = format
      this.replayFormat = 'jpg'
      this.replay()
    },
    replayGIF () {
      // this.replayFormat = format
      this.replayFormat = 'gif'
      this.replay()
    },
    replayPNG () {
      // this.replayFormat = format
      this.replayFormat = 'png'
      this.replay()
    },
    cancel () {
      this.startLoading()
      // this.creativeUnitData = this.originalCreativeUnitData
      // this.creativeUnitData = Object.assign({}, this.originalCreativeUnitData)
      this.refreshCreativeUnit()
      this.editing = false
      this.addNotification('success', 'Changes Cancelled')
    },
    thumbPath (filename) {
      var clientSlug = this.creativeUnit.creative.campaign.client.slug
      var campaignHashId = this.creativeUnit.creative.campaign.hash_id
      var creativeHashId = this.creativeUnit.creative.hash_id
      var thumbpath = MEDIA_URL + clientSlug.toLowerCase() + '/' + campaignHashId + '/' + creativeHashId + '/_assets/' + filename + '?ts=' + Math.round(+new Date() / 1000)
      return thumbpath
    },
    videoThumbPath (filename) {
      var clientSlug = this.creativeUnit.creative.campaign.client.slug
      var campaignHashId = this.creativeUnit.creative.campaign.hash_id
      var creativeHashId = this.creativeUnit.creative.hash_id
      var thumbpath = MEDIA_URL + clientSlug.toLowerCase() + '/' + campaignHashId + '/' + creativeHashId + '/_thumbnails/' + filename + '_thumb.jpeg' + '?ts=' + Math.round(+new Date() / 1000)
      return thumbpath
    },
    statusCss (status) {
      let labelType = 'default'
      if (status !== 'new') {
        labelType = this.statusKeys[status]
      }
      return `label label-${labelType} text-center text-capitalize`
    },
    updateImage (e) {
      if (this.disableEdition()) return
      this.onLaunchModal(e)
    },
    onSelectImage (id, field, image, fieldType) {
      // const index = findIndex(propEq('id', id))(this.creativeUnit)
      this.creativeUnit.data[field] = image
      // if its a video then also take this extra step
      if (fieldType === 'video') {
        var video = document.getElementById(field)
        video.setAttribute('src', this.thumbPath(image))
      }
      this.checkEditing(field, image)
    },
    renderUnit () {
      var action = 'render'
      this.submitAction(action)
    },
    submitAction (action) {
      const data = {
        id: this.creativeUnit.creative.hash_id,
        action: action,
        units: [this.creativeUnitId] // this.getSelected().ids
      }
      this.startLoading()
      this.updateBulkCreative(data).then((response) => {
        // if response includes preview link show preview link modal
        this.getCreativeUnit(this.creativeUnitId).then(() => {
          this.refreshCreativeUnit()
          this.finishLoading()
          if (action === 'render') {
            this.pollRender()
            this.addNotification('info', 'Creative unit sent to queue.')
            return
          }
          this.addNotification('success', response.reason)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    },
    saveUnit () {
      const existingId = this.creativeUnit.id
      this.editing = !this.editing
      // If clicked on save editing,
      // send creative unit to API.
      if (!this.editing) {
        this.updateAllUnitData(existingId)
      }
    },
    updateAllUnitData (id) {
      this.startLoading()
      const data = {
        id: id,
        columns: this.generateUnitColumnsArray(),
        unit: this.generateUnitsArray(id, this.creativeUnit)
      }
      this.updateSingleCreativeUnit(data).then((response) => {
        this.refreshCreativeUnit()
        this.finishLoading()
        this.addNotification('success', 'Unit succesfully saved')
      })
    },
    refreshCreativeUnit () {
      this.getCreativeUnit(this.creativeUnitId).then(() => {
        this.creativeUnit = this.creativeUnits.creativeUnits
        this.creativeUnitData = this.creativeUnit.data
        this.creativeName = this.creativeUnit.master + ' - ' + this.creativeUnit.locale
        this.creativeUnitSystemData.master = this.creativeUnit.master
        this.creativeUnitSystemData.locale = this.creativeUnit.locale
        this.creativeUnitSystemData.width = this.creativeUnit.width
        this.creativeUnitSystemData.height = this.creativeUnit.height
        if (this.creativeUnit.creative.type === 'html-video') {
          this.creativeUnitSystemData.render_video_duration = this.creativeUnit.render_video_duration
          this.creativeUnitSystemData.render_video_fps = this.creativeUnit.render_video_fps
          this.creativeUnitSystemData.render_video_format = this.creativeUnit.render_video_format
        }
        this.breadcrumb = this.breadcrumbData
        this.status = this.creativeUnit.status
        this.type = this.creativeUnit.creative.type
        this.charges.alreadyDownloaded = this.creativeUnit.is_downloaded
        this.charges.downloadCost = this.creativeUnit.creative.campaign.client.download_cost
        this.charges.currency = this.creativeUnit.creative.campaign.client.currency
        this.date_created = this.creativeUnit.date_created.value
        this.originalCreativeUnitData = Object.assign({}, this.creativeUnitData)
        this.originalCreativeUnitSystemData = Object.assign({}, this.creativeUnitSystemData)
        if (this.status === 'queued') {
          this.pollRender()
        }
        this.createPreview()
        this.finishLoading()
      })
    },
    generateUnitColumnsArray () {
      return ['id', 'master', 'locale', 'width', 'height',
        ...(this.type === 'html-video' ? ['render_video_duration', 'render_video_fps', 'render_video_format'] : []),
        ...this.fields]
    },
    generateUnitsArray () {
      const units = []
      // TO DO EXTRACT THE DATA ARRAY PROPERLY
      const unitData = Object.values(this.creativeUnitData)
      const unit = [
        this.creativeUnitId,
        this.creativeUnitSystemData.master,
        this.creativeUnitSystemData.locale,
        this.creativeUnitSystemData.width,
        this.creativeUnitSystemData.height,
        ...(this.type === 'html-video'
          ? [this.creativeUnitSystemData.render_video_duration,
            this.creativeUnitSystemData.render_video_fps,
            this.creativeUnitSystemData.render_video_format] : []),
        ...unitData
      ]
      units.push(unit)
      return units
    },
    checkEditing (key, value) {
      if (this.originalCreativeUnitData[key] !== value) {
        this.editing = true
      }
    },
    checkSelection (key, event) {
      if (this.originalCreativeUnitData[key] !== event.target.value) {
        this.editing = true
      }
    },
    checkEditingSystem (name, value) {
      if (this.originalCreativeUnitSystemData[name] !== value) {
        this.editing = true
      }
    },
    onLaunchChargeModal (format) {
      this.calculateCharges()
      if (this.charges.alreadyDownloaded === true) {
        this.downloadFile(format)
        return
      }
      this.charges.downloadFormat = format
      this.showModal['chargeSingleConfirmation'] = true
    },
    downloadFile (format) {
      // do something
      this.startLoading()
      this.createSignedDownloadRequest({
        domain: 'single-creative-unit',
        resource: this.creativeId,
        creativeHashId: this.creativeId,
        creativeUnitId: this.creativeUnitId,
        extension: `export-${format}`
      }).then(response => {
        this.finishLoading()
        if (!response.success) {
          alert('Try again later')
          return
        }
        this.charges.alreadyDownloaded = true
        window.open(API_URL + response.link.substring(1), '_blank')
      }).catch(reason => {
        this.finishLoading()
        alert(reason)
      })
    },
    calculateCharges () {
      const charges = {
        downloadCost: this.charges.downloadCost,
        currency: this.charges.currency,
        alreadyDownloaded: this.charges.alreadyDownloaded
      }
      this.charges = charges
    },
    setDefault (key) {
      if (this.creativeUnitData[key] !== this.fieldData(key).defaultValue) {
        this.editing = true
        this.creativeUnitData[key] = this.fieldData(key).defaultValue
      }
    },
    revertChange (key) {
      // Revert the change
      this.creativeUnitData[key] = this.originalCreativeUnitData[key]
      // check to see if there are any outstanding changes
      for (var field in this.creativeUnitData) {
        if (this.creativeUnitData[field] !== this.originalCreativeUnitData[field]) {
          this.editing = true
          return
        }
        this.editing = false
      }
      // check to see if there are any outstanding changes in creative mandatory data (System)
      for (var fields in this.creativeUnitSystemData) {
        if (this.creativeUnitSystemData[fields] !== this.originalCreativeUnitSystemData[fields]) {
          this.editing = true
          return
        }
        this.editing = false
      }
    },
    revertChangeSystem (key) {
      // Revert the change
      this.creativeUnitSystemData[key] = this.originalCreativeUnitSystemData[key]
      // check to see if there are any outstanding changes in creative data
      for (var field in this.creativeUnitData) {
        if (this.creativeUnitData[field] !== this.originalCreativeUnitData[field]) {
          this.editing = true
          return
        }
        this.editing = false
      }
      // check to see if there are any outstanding changes in creative mandatory data (System)
      for (var fields in this.creativeUnitSystemData) {
        if (this.creativeUnitSystemData[fields] !== this.originalCreativeUnitSystemData[fields]) {
          this.editing = true
          return
        }
        this.editing = false
      }
    }
  },
  computed: {
    creativeUnitId () {
      return this.$route.params.sid
    },
    creativeId () {
      return this.$route.params.id
    },
    baseUrl () {
      return url
    },
    dev () {
      return devMode
    },
    previewUrl () {
      // Handle the local environment cases
      // Non local cases
      if (this.creativeUnit.previewUrl == null) {
        return API_URL + 'assets/img/placeholder.png'
      } else {
        if (this.type === 'html') {
          return API_URL + this.creativeUnit.previewUrl
        }
        var newUrl = this.creativeUnit.previewUrl
        if (this.type === 'psd' && this.replayFormat === 'png') {
          newUrl = this.creativeUnit.previewUrl.slice(0, -3) + 'png'
          return API_URL + newUrl
        }
        if (this.type === 'psd' && this.replayFormat === 'gif') {
          newUrl = this.creativeUnit.previewUrl.slice(0, -3) + 'gif'
          return API_URL + newUrl
        }
        if (this.type === 'psd' && this.replayFormat === 'jpg') {
          newUrl = this.creativeUnit.previewUrl.slice(0, -3) + 'jpg'
          return API_URL + newUrl
        }
      }
    },
    fields () {
      var s = this.creativeUnit.data
      var keys = []
      for (var k in s) keys.push(k)
      return keys
    },
    breadcrumbData () {
      return [
        {
          name: this.creativeUnit.creative.campaign.client.name,
          path: `client/${this.creativeUnit.creative.campaign.client.hash_id}`
        },
        {
          name: this.creativeUnit.creative.campaign.name,
          path: `campaigns/${this.creativeUnit.creative.campaign.hash_id}`
        },
        {
          name: this.creativeUnit.creative.name,
          path: `creatives/${this.creativeUnit.creative.hash_id}/bulk`
        },
        {
          name: this.creativeName,
          path: '',
          active: true
        }
      ]
    },
    downloadCost () {
      if (this.creativeUnit) {
        return this.creativeUnit.creative.campaign.client.download_cost
      }
    },
    currency () {
      if (this.creativeUnit) {
        return this.creativeUnit.creative.campaign.client.currency
      }
    },
    fpsOptions () {
      return {
        12: 12,
        15: 15,
        24: 24,
        29: 29,
        30: 30,
        50: 50,
        60: 60
      }
    },
    videoFormats () {
      return {
        mp4: 'mp4',
        gif: 'gif'
      }
    },
    videoPreview () {
      return {
        type: this.creativeUnit.render_video_format,
        url: `${API_URL}${this.creativeUnit.videoUrl}/video.${this.creativeUnit.render_video_format}`
      }
    }
  },
  beforeDestroy () {
    if (this.type === 'html-video') {
      document.removeEventListener('contextmenu', this.disableContextMenu, false)
    }
  }
}
</script>

<style lang="scss">
    .singleCreativeUnit {
      & textarea.form-control {
        min-height: 50px;
        resize: vertical;
        &::placeholder {
          color: lightgrey;
          font-style: italic;
        }
      }

      & .field, .imageHolder {
        border: 1px solid lightgrey;
        padding: 5px 10px 10px;
        border-radius: 10px;
      }

      & .set-default {
        margin-left:5px;
      }
      & .colorPicker {
        border:1px solid #ccc;
        background-color:#eee;
        border-radius: 5px;
        width:100%;
        padding:4px;
        text-align: left;
        margin: 0 auto;
        padding: 10px 12px;
        font-size: 14px;
        font-weight: normal;
        line-height: 1;
        & span {
          border: 1px solid #ccc;
          height: 16px;
          width: 16px;
          display: inline-block;
          float: right;
        }
      }
      & .imageHolder {
        & .imageHolderContent {
          border: 1px solid lightgrey;
          padding: 15px;
        }
        & img {
          border:1px solid black;
          max-width: 100%;
          max-height: 300px;
          display: block;
          margin: 0 auto;
          background-color: #ccc;
          background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%,
          transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)),
          linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%,
          transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));
          background-size: 10px 10px;
          background-position: 0 0, 5px 5px;
        }
        & label {
          text-align: left;
        }
        & .imageName {
          margin-bottom: 5px;
          & span {
            font-style: italic;
          }
        }
      }
      & .Tooltip__content {
        justify-content: left;
        max-width: 100px;
      }
      & .sticky-top, & .sticky-top-last {
        position: sticky;
        top: 0;
        background-color: white;
        z-index: 20;
        padding-bottom: 20px;
        margin-bottom: 10px;
      }
      & .sticky-top-last {
        box-shadow: 0 8px 5px -5px gray;
      }
      & .headingWrap__title {
          width:100%;
      }
      & #previewHolder {
        border: 1px solid lightgrey;
        border-radius: 5px;
        padding-top:10px;
        overflow: hidden;
      }
      & #iframeHolder {
        position: static;
      }
      & #iframeCover {
        z-index:50;
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
      }
      & #iFrameContainer {
        position: relative;
        margin: 0 auto;
        overflow:hidden;
      }
      & .replayHolder {
        margin-top:10px;
        margin-bottom:10px;
      }

      & .headingWrap__nav {
        display: none;
      }

      & .fa-spinner {
        animation: spin 2s infinite linear;
      }
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      &__video-preview {
        z-index: 51;
        position: absolute;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/creatives/single-creative-unit.vue